import { useEffect, useRef } from "react";
import { APP_EVENTS, Game } from "@phaser/Game";
import { App } from "@capacitor/app";
import { Capacitor, type PluginListenerHandle } from "@capacitor/core";
import { AudioManager } from "@/phaser/core/audio/AudioManager";

export default function GamePage() {
  const gameRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!gameRef.current) return;

    let game: Game | null = null;
    let appStateSub: PluginListenerHandle | null = null;

    // 폰트가 모두 로드된 후에 Phaser Game 생성
    const startGame = async () => {
      game = new Game(gameRef.current!);

      if (Capacitor.isNativePlatform()) {
        appStateSub = await App.addListener(
          "appStateChange",
          ({ isActive }) => {
            if (!game) return;
            game.appEvents.emit(
              isActive ? APP_EVENTS.FOREGROUND : APP_EVENTS.BACKGROUND,
            );

            if (!isActive) {
              AudioManager.pauseForBackground();
            } else {
              AudioManager.resumeFromBackground();
            }
          },
        );
      } else {
        const onVis = () => {
          if (!game) return;
          const isActive = !document.hidden;
          game.appEvents.emit(
            isActive ? APP_EVENTS.FOREGROUND : APP_EVENTS.BACKGROUND,
          );

          if (!isActive) AudioManager.pauseForBackground();
          else AudioManager.resumeFromBackground();
        };
        document.addEventListener("visibilitychange", onVis);
      }
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(startGame).catch(startGame);
    } else {
      startGame();
    }

    return () => {
      appStateSub?.remove();
      appStateSub = null;

      game?.destroy(true);
      game = null;
    };
  }, []);

  return (
    <div
      ref={gameRef}
      style={{
        width: "100%",
        height: "100%",
      }}
    ></div>
  );
}
